module.exports = __webpack_public_path__ + "static/other/lab_diagnosis_test_tube_info_scene.af480869.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/labDiagnosisGame/lab_diagnosis_test_tube_info_scene.json
// module id = 2231
// module chunks = 0